module.exports = __webpack_public_path__ + "static/img/11.07bf4ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/11.jpg
// module id = BU3T
// module chunks = 0